import { memo, useCallback, useContext, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "../../hooks/useNavigate";
import { MixpanelContext } from "../../context/AnalyticsService";
import { getAccountState, LoginState } from "../../redux/slices/accountSlice";
import { Colors } from "../../utils/colors";
import { FoldHeaderText } from "./SubComponents/FoldHeaderText";
import SubscriptionPlans from "../Subscription/SubscriptionPlans";
import { PlanTypeV4 } from "@markit/common.types";
import { NavigationId } from "../../navigation/AppParamList";
import { LoginStage } from "../../screens/Login/LoginWelcome";

type PricingFoldProps = {
  isDesktopSize: boolean;
};

const PricingFold = (props: PricingFoldProps) => {
  const { isDesktopSize } = props;
  const { account } = useSelector(getAccountState);
  const { accountData, loggedIn } = account;
  const mixpanel = useContext(MixpanelContext);
  const navigate = useNavigate();
  const [selectedCardOption, setSelectedCardOption] = useState(2);

  const signUpForPlanOnPress = useCallback(
    (cardOption: number) => {
      if (mixpanel) {
        mixpanel.track("Website: Pricing Pressed Subscription Plan", {
          distinct_id: accountData.uid,
          is_logged_in: loggedIn === LoginState.LOGGED_IN,
          plan:
            cardOption === 0
              ? PlanTypeV4.FREE.name
              : cardOption === 1
                ? PlanTypeV4.ESSENTIAL.name
                : cardOption === 2
                  ? PlanTypeV4.PRO.name
                  : PlanTypeV4.BUSINESS.name,
        });
      }
      if (loggedIn === LoginState.LOGGED_IN && accountData.inCreatorMode) {
        navigate("/home");
      } else {
        navigate(NavigationId.SIGN_IN, {
          state: { preLoginStage: LoginStage.EMAIL_SIGNUP },
        });
      }
    },
    [accountData.inCreatorMode, accountData.uid, loggedIn, mixpanel, navigate]
  );

  return (
    <div
      className="ColumnNormal"
      style={{
        gap: 24,
        width: "100%",
        maxWidth: 1472,
        margin: "0 auto",
        color: Colors.WHITE,
        boxSizing: "border-box",
      }}
    >
      <div
        className={isDesktopSize ? "AlignedRowSpaced" : "ColumnCentering"}
        style={{
          gap: isDesktopSize ? 40 : 14,
          alignItems: isDesktopSize ? "center" : "flex-start",
        }}
      >
        <FoldHeaderText isDesktopSize={isDesktopSize}>Pricing</FoldHeaderText>
        <span
          className="landingPageHeaderSubtext"
          style={{
            maxWidth: isDesktopSize ? 420 : undefined,
            textAlign: isDesktopSize ? undefined : "left",
          }}
        >
          Markit is free to use. Upgrade to Markit+ to explore additional
          features and unlock unlimited texting.
        </span>
      </div>
      <div
        className="slide-up"
        style={{
          marginTop: isDesktopSize ? 16 : 8,
          width: "100%",
          minWidth: 0,
          boxSizing: "border-box",
        }}
      >
        <SubscriptionPlans
          selectedCardOption={selectedCardOption}
          setSelectedCardOption={setSelectedCardOption}
          itemOnPress={signUpForPlanOnPress}
          homePage
          contentPaddingInline={0}
        />
      </div>
    </div>
  );
};

export default memo(PricingFold);
